import { API } from 'services/constants';
import axios from 'services/axios';
import { default as mockAxios } from 'utils/axios';
import moment from 'moment';

const createAction = name => ({
  BRANCH_CHIP_CHANGE: `${name}_BRANCH_CHIP_CHANGE`,
  DEVICE_CHIP_CHANGE: `${name}_DEVICE_CHIP_CHANGE`,
  QR_CHIP_CHANGE: `${name}_QR_CHIP_CHANGE`,
  START_DATE_CHANGE: `${name}_START_DATE_CHANGE`,
  END_DATE_CHANGE: `${name}_END_DATE_CHANGE`,
  START_AMOUNT_CHANGE: `${name}_START_AMOUNT_CHANGE`,
  END_AMOUNT_CHANGE: `${name}_END_AMOUNT_CHANGE`,
  CHARGE_STATUS_CHANGE: `${name}_CHARGE_STATUS_CHANGE`,
  GET_CHARGE_PENDING: `${name}_GET_CHARGE_PENDING`,
  GET_CHARGE_SUCCESS: `${name}_GET_CHARGE_SUCCESS`,
  GET_CHARGE_FALIED: `${name}_GET_CHARGE_FALIED`
});

export const CHARGE = createAction('CHARGE');

export const ChargeBranchChipChange = value => dispatch => {
  dispatch({
    type: CHARGE.BRANCH_CHIP_CHANGE,
    payload: value
  });
};

export const ChargeDeviceChipChange = value => dispatch => {
  dispatch({
    type: CHARGE.DEVICE_CHIP_CHANGE,
    payload: value
  });
};

export const ChargeQrChipChange = value => dispatch => {
  dispatch({
    type: CHARGE.QR_CHIP_CHANGE,
    payload: value
  });
};

export const ChargeStartDateChange = value => dispatch => {
  dispatch({
    type: CHARGE.START_DATE_CHANGE,
    payload: value
  });
};

export const ChargeEndDateChange = value => dispatch => {
  dispatch({
    type: CHARGE.END_DATE_CHANGE,
    payload: value
  });
};

export const ChargeStartAmountChange = value => dispatch => {
  dispatch({
    type: CHARGE.START_AMOUNT_CHANGE,
    payload: value
  });
};

export const ChargeEndAmountChange = value => dispatch => {
  dispatch({
    type: CHARGE.END_AMOUNT_CHANGE,
    payload: value
  });
};

export const ChargeStatusChange = value => dispatch => {
  dispatch({
    type: CHARGE.CHARGE_STATUS_CHANGE,
    payload: value
  });
};

export const GetMockCharge = () => async (dispatch, getState) => {
  dispatch({ type: CHARGE.GET_CHARGE_PENDING });
  try {
    const result = await mockAxios
      .get('/api/charge')
      .then(res => res.data)
      .catch(err => Promise.reject(err));

    dispatch({
      type: CHARGE.GET_CHARGE_SUCCESS,
      payload: result
    });
  } catch (error) {
    dispatch({
      type: CHARGE.GET_CHARGE_FALIED,
      error
    });
  }
};

export const GetCharge = () => async (dispatch, getState) => {
  // dispatch({ type: CHARGE.GET_CHARGE_PENDING });
  try {
    const { authen, company, charge } = getState();
    const { loginUser } = authen;
    const {
      branchChips,
      deviceChips,
      qrChips,
      startDate,
      endDate,
      startAmount,
      endAmount,
      status
    } = charge;

    const _companyId = company.select.id;

    let branchIds = [];
    let deviceIds = [];
    let qrTypes = [];

    branchChips.forEach(item => {
      branchIds = [...branchIds, item.id];
    });

    deviceChips.forEach(item => {
      deviceIds = [...deviceIds, item.id];
    });

    qrChips.forEach(item => {
      qrTypes = [...qrTypes, item.id];
    });

    const params = {
      companyId: loginUser.role === 'super' ? _companyId : loginUser.companyId,
      branchIds: branchIds,
      startDate: moment(startDate).format('YYYY-MM-DD'),
      endDate: moment(endDate).format('YYYY-MM-DD'),
      startAmount: startAmount, // === 0 ? parseFloat(1).toFixed(2) : parseFloat(startAmount).toFixed(2),
      endAmount: endAmount, // === 0 ? parseFloat(1000000).toFixed(2) : parseFloat(endAmount).toFixed(2),
      status: status === 'Select all' ? null : status,
      deviceIds: deviceIds,
      qrTypes: qrTypes
    };
    console.log(JSON.stringify(params));
    const result = await axios
      .post(API.POST_INQUIRY_CHARGE, params)
      .then(res => res.data)
      .catch(err => Promise.reject(err));

    // POST_INQUIRY_TRANSACTION: '/inquiry/transaction',
    // POST_INQUIRY_CHART: '/inquiry/chart'

    console.log(result);

    dispatch({
      type: CHARGE.GET_CHARGE_SUCCESS,
      payload: result
    });
  } catch (error) {
    dispatch({
      type: CHARGE.GET_CHARGE_FALIED,
      error
    });
  }
};
